import NiceModal from "@ebay/nice-modal-react";

import style from "./AddressKrModal.module.css";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import DaumPostcodeEmbed from "react-daum-postcode";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import ModalBase from "modals/base/ModalBase";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import InputText from "components/inputs/signUp/InputText";
import CustomButton from "components/buttons/CustomButton";




const AddressKrModal = NiceModal.create(
    (props, ref) => {
        const { isMobile } = useContext(BrowserDetectContext);
        const modal = useRef();
        const [withHeader, withFooter] = [true,
            false];
        const [width, height] = [isMobile ? "90%" : "40%", isMobile ? "60vh" : "50%"];
        const withCloseButton = false;
        const clickOutsideToClose = false;
        const title = "주소 찾기";
        const { id } = props;
        const buttonText = "close";
        const { t } = useTranslation();
        const inputRef = useRef();
        const [data, setData] = useState();
        const [modalData, setModalData] = useState(null);
        const [text, setText] = useState("");


        const complete = (data) => {
            let fullAddress = data.address;
            let extraAddress = '';

            if (data.addressType === 'R') {
                if (data.bname !== '') {
                    extraAddress += data.bname;
                }
                if (data.buildingName !== '') {
                    extraAddress += (extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName);
                }
                fullAddress += (extraAddress !== '' ? ` (${extraAddress})` : '');

            }
            const dataToPassBack = {
                address: fullAddress,
                zonecode: data.zonecode,
                // ... 기타 데이터
            };
            
            setData(dataToPassBack);
            // inputRef.current.setValue(fullAddress);
            // setText("나머지 주소를 입력해주세요");



        }
        useEffect(() => {
            if (data) {
                
                if (props.onCallback) {
                    props.onCallback(data);
                }
    
                modal.current.close();
            }

        }, [data])
        

        return (
            <ModalBase borderRadius={"25px"} ref={modal} width={width} height={height} withHeader={withHeader} withFooter={withFooter} withCloseButton={withCloseButton} clickOutsideToClose={clickOutsideToClose} title={title} buttonText={buttonText}>
                <div className={style.wrap}>
                    <VerticalFlex gap={20}>
                        <FlexChild>

                            <DaumPostcodeEmbed
                                className={style.postmodal}
                                autoClose
                                onComplete={complete} />

                        </FlexChild>
                        <FlexChild>

                        </FlexChild>
                        {/* <FlexChild>
                            <HorizontalFlex gap={20}>
                                <FlexChild width={"70%"}>
                                    <VerticalFlex>

                                        <FlexChild>
                                            <InputText readOnly ref={inputRef} />
                                        </FlexChild>
                                    </VerticalFlex>
                                </FlexChild>
                                <FlexChild>
                                    <CustomButton text={"입력"} onClick={onClick} />
                                </FlexChild>
                            </HorizontalFlex>
                        </FlexChild> */}
                    </VerticalFlex>
                </div>
            </ModalBase>
        );
    }
);

export default AddressKrModal;